import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { AirState } from './types'

const INITIAL_STATE: AirState = {
  airportsError: false,
  airportsList: [],
  airportsLoading: false,
  historyError: '',
  historyList: [],
  historyLoading: false,
  searches: {},
  searchType: null
}

const reducer = createReducer<AirState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getAir, (state, { payload }) => ({
    ...state,
    searchType: payload.searchType,
    searches:
      payload.searchType === 'MULTI-STRETCH'
        ? {
            ...state.searches,
            [payload.searchKey]: {
              error: '',
              list: [],
              loading: true,
              message_id: []
            }
          }
        : {
            [`${payload.from_airport}-${payload.to_airport}`]: {
              error: '',
              list: [],
              loading: true,
              message_id: []
            }
          }
  }))
  .handleAction(Actions.getAirFailure, (state, { payload }) => ({
    ...state,
    searches: {
      ...state.searches,
      [payload.searchKey]: {
        ...state.searches[payload.searchKey],
        error: payload.message,
        loading: false
      }
    }
  }))
  .handleAction(Actions.getAirSuccess, (state, { payload }) => ({
    ...state,
    searches: {
      ...state.searches,
      [payload.searchKey]: {
        ...state.searches[payload.searchKey],
        list: [...payload.resume_air],
        loading: false,
        message_id: [...payload.message_id]
      }
    }
  }))
  .handleAction(Actions.getAirHistory, (state, { payload }) => ({
    ...state,
    ...payload,
    historyError: '',
    historyLoading: true,
    historyList: []
  }))
  .handleAction(Actions.getAirHistoryFailure, (state, { payload }) => ({
    ...state,
    historyError: payload.message,
    historyLoading: false
  }))
  .handleAction(Actions.getAirHistorySuccess, (state, { payload }) => ({
    ...state,
    ...payload,
    historyLoading: false
  }))
  .handleAction(Actions.getAirports, state => ({
    ...state,
    airportsError: false,
    airportsList: [],
    airportsLoading: true
  }))
  .handleAction(Actions.getAirportsFailure, state => ({
    ...state,
    airportsError: true,
    airportsLoading: false
  }))
  .handleAction(Actions.getAirportsSuccess, (state, { payload }) => ({
    ...state,
    airportsList: payload.list,
    airportsLoading: false
  }))
  .handleAction(Actions.resetAir, () => ({
    ...INITIAL_STATE
  }))

export default reducer
